import {
  UTC,
  DateRange,
}                                  from 'rewire-common';
import mainPageModel               from '../main-navigation/MainPageModel';
import DateRangeNavModel, {
  DateDuration,
}                                  from './DateRangeNavModel';
import { RouteManagerBase }        from '../main-navigation/RouteManager';
import { getCustomFormDatePicker } from '../ui/MainCustomFormDatePicker';

// these values are never accessed without the effective having a value (because of the route manager update that is called before any content that makes use of MainDateRangeNav is shown).
// Overriding getters to reflect that in the retun types.
class MainDateRangeNavModel extends DateRangeNavModel {
  get effective(): DateRange {
    return this.state.effective!;
  }

  get startDate(): UTC {
    return this.effective!.start;
  }

  get endDate(): UTC {
    return this.effective!.end;
  }

  get startDateStartOfDay(): UTC {
    return this.effective!.start.clone().startOfDay();
  }

  get endDateStartOfDay(): UTC {
    return this.effective!.end.clone().startOfDay();
  }

  get numOfDays(): number {
    return this.effective!.length;
  }
}

function onStartDateChange(startDate: UTC, effective: DateRange) {
  RouteManagerBase.current.navigateTo({ effective });
}

function onEndDateChange(endDate: UTC, effective: DateRange) {
  RouteManagerBase.current.navigateTo({ effective });
}

function onDateDurationChange(dateDuration: DateDuration, effective: DateRange) {
  mainPageModel.dateDuration = dateDuration;
  RouteManagerBase.current.navigateTo({ effective });
}

const mainDateRangeNavModel = new MainDateRangeNavModel(onStartDateChange, onEndDateChange, onDateDurationChange, getCustomFormDatePicker);
export default mainDateRangeNavModel;
